<template>
  <div class="container">
    <div class="section-container">
      <div class="navigation">
        <Link :href="$route('company.register')">
          <Button class="btn--tonal">¿Aún no tienes cuenta?</Button>
        </Link>
      </div>
      <div class="form-container">
        <header>
          <h1 class="headline-large">Iniciar sesión</h1>
          <p class="title-large">Lorem ipsum dolor sit, amet consectetur adipisicing elit.</p>
        </header>
        <div v-if="errors.credentials" class="error-box">
          Credenciales incorrectas.
        </div>
        <form @submit.prevent="login" class="py-3">
          <text-input
            id="email"
            v-model="form.email"
            type="email"
            label="Correo empresarial"
            icon="mail-outline"
            :required="true"
          />
          <text-input
            id="password"
            v-model="form.password"
            type="password"
            label="Contraseña"
            icon="lock-outline"
            :required="true"
          />
          <Link :href="$route('password.request')" class="btn--text-link"
            >Olvidé mi contraseña</Link
          >
          <Button type="submit" class="d-block my-3 mx-auto btn--filled" :isLoading="form.progress">
            Iniciar sesión
          </Button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue'
import Layout from '@/Layouts/LayoutEmpresas'
import Button from '@/Components/Button'
import TextInput from '@/Components/Form/TextInput'

export default {
  name: 'Ingreso',
  layout: Layout,
  props: {
    errors: Object,
  },
  components: {
    Link,
    Button,
    TextInput,
  },
  data() {
    return {
      form: this.$inertia.form({
        email: '',
        password: '',
      }),
    }
  },
  methods: {
    login() {
      this.form.post(this.$route('company.login.store'), this.form)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../scss/utilities/theme';
@import '../../../scss/utilities/mixins';

.container {
  display: flex;
  justify-content: center;

  .section-container {
    padding-top: 56px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;

    .form-container {
      @include md1 {
        margin: 0px 48px;
      }
    }

    .navigation {
      display: flex;
      justify-content: right;
    }

    // Apply styles on large screens
    @include md1 {
      width: 552px;
    }
  }
}
</style>
